import { render, staticRenderFns } from "./pointsList.vue?vue&type=template&id=7935ea1a&scoped=true"
import script from "./pointsList.vue?vue&type=script&lang=js"
export * from "./pointsList.vue?vue&type=script&lang=js"
import style0 from "./pointsList.vue?vue&type=style&index=0&id=7935ea1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7935ea1a",
  null
  
)

export default component.exports